/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AbuseServiceShadowbanUserRequest } from '../../models/abuse-service-shadowban-user-request';
import { ShadowbanUserResponse } from '../../models/shadowban-user-response';

export interface AbuseServiceShadowbanUser$Params {
  userId: string;
      body: AbuseServiceShadowbanUserRequest
}

export function abuseServiceShadowbanUser(http: HttpClient, rootUrl: string, params: AbuseServiceShadowbanUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ShadowbanUserResponse>> {
  const rb = new RequestBuilder(rootUrl, abuseServiceShadowbanUser.PATH, 'post');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShadowbanUserResponse>;
    })
  );
}

abuseServiceShadowbanUser.PATH = '/api/v3/gateway/admin/shadowban/{userId}';
